export default __webpack_public_path__ + "static/media/720px-440px-square-PMR-Dev-no-border.1479d627.jpg";